module.exports = __webpack_public_path__ + "static/media/arrow-right.6b7b3b83.svg";